export default __webpack_public_path__ + "static/media/Vinfast.f5038be5.png";